module.exports = __webpack_public_path__ + "static/media/management-activated.5032b205.svg";